import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import './minimum-quantity-text.scss';
type MinimumQuantityTextProps = Readonly<{
  minimumQuantity: number;
  className?: string;
  testId?: string;
}>;
const MINIMUM_QUANTITY_DISPLAY_THRESHOLD = 2;
export const MinimumQuantityText = t0 => {
  const $ = _c(6);
  const {
    minimumQuantity,
    className,
    testId: t1
  } = t0;
  const testId = t1 === undefined ? "minimum-qty" : t1;
  if (minimumQuantity < MINIMUM_QUANTITY_DISPLAY_THRESHOLD) {
    return null;
  }
  let t2;
  if ($[0] !== className) {
    t2 = cn("minimum-quantity-text", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== minimumQuantity || $[3] !== t2 || $[4] !== testId) {
    t3 = <TextPassage data-testid={testId} className={t2}>Minimum quantity of {minimumQuantity} required</TextPassage>;
    $[2] = minimumQuantity;
    $[3] = t2;
    $[4] = testId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};